// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MNhG","selected":"styles_selected__2x94e"};